module.exports = __webpack_public_path__ + "img/footer-wx.9f303392.jpg";